
import {define} from "observable:runtime";
import asset1 from "./style.css?url";
import asset2 from "./favicon.svg?url";

const assets = new Map([
  ["./style.css", asset1],
  ["./favicon.svg", asset2]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const [{createUI, installThemeToggle, installHashImportBanner}, {createGameUI, loadGame, prepareGameFile}] = await Promise.all([import("./lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  return module;
}), import("./lib/bgio.js").then((module) => {
  if (!("createGameUI" in module)) throw new SyntaxError(`export 'createGameUI' not found`);
  if (!("loadGame" in module)) throw new SyntaxError(`export 'loadGame' not found`);
  if (!("prepareGameFile" in module)) throw new SyntaxError(`export 'prepareGameFile' not found`);
  return module;
})]);
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, ok, err, hint } = createUI({ html });
const { gameBoard, mountEditor, mountGameSection } = createGameUI({ html });
const starter = prepareGameFile(4);
return {createUI,installThemeToggle,installHashImportBanner,createGameUI,loadGame,prepareGameFile,codeEditor,ok,err,hint,gameBoard,mountEditor,mountGameSection,starter};
},
    inputs: ["html","display"],
    outputs: ["createUI","installThemeToggle","installHashImportBanner","createGameUI","loadGame","prepareGameFile","codeEditor","ok","err","hint","gameBoard","mountEditor","mountGameSection","starter"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-3`),
    expanded: [],
    variables: []
  },
  {
    id: 3,
    body: (codeEditor,starter,html,loadGame,err,ok,gameBoard,mountEditor,mountGameSection) => {
const editor = codeEditor("bgio:game", { value: starter, label: "Deine Datei: TicTacToe.js" });
const boardSlot = html`<div></div>`;
const feedbackSlot = html`<div></div>`;

function check(code) {
  try {
    const game = loadGame(code);
    if (!game.ai || typeof game.ai.enumerate !== "function")
      return err(html`Es fehlt die <code>ai.enumerate</code>-Funktion.`);

    const indicesFor = (cells) => {
      const res = game.ai.enumerate({ cells }, { currentPlayer: "0" }, "0");
      if (!Array.isArray(res)) return null;
      if (!res.every(m => m && m.move === "clickCell" && Array.isArray(m.args) && m.args.length === 1)) return "shape";
      return res.map(m => m.args[0]).sort((a, b) => a - b);
    };
    const empty = indicesFor([null, null, null, null, null, null, null, null, null]);
    const partial = indicesFor(["0", null, "1", null, null, "1", null, "0", null]); // empty: 1,3,4,6,8
    const eq = (a, b) => Array.isArray(a) && a.length === b.length && a.every((v, i) => v === b[i]);

    if (empty === null || partial === null)
      return err(html`<code>enumerate</code> muss ein <strong>Array</strong> von Zügen zurückgeben.`);
    if (empty === "shape" || partial === "shape")
      return err(html`Jeder Zug muss die Form <code>{ move: 'clickCell', args: [index] }</code> haben.`);
    if (!eq(empty, [0, 1, 2, 3, 4, 5, 6, 7, 8]))
      return err(html`Auf einem leeren Feld sollte <code>enumerate</code> <strong>9</strong> Züge liefern — du gibst ${empty.length} zurück.`);
    if (!eq(partial, [1, 3, 4, 6, 8]))
      return err(html`<code>enumerate</code> soll nur Züge für <strong>leere</strong> Zellen liefern. Erwartet: 1, 3, 4, 6, 8 — bekommen: ${partial.join(", ") || "keine"}.`);
    return ok(html`🎉 Geschafft! Dein Bot kennt alle möglichen Züge und spielt ein ganzes Spiel. Probier ⏩ simulate!`);
  } catch (e) {
    return err(html`Dein Code lässt sich nicht ausführen: ${e.message}`);
  }
}

function rerun() {
  const code = editor.value;
  boardSlot.replaceChildren(gameBoard(code, {
    showDebug: true,
    showBot: true,
    showState: true,
    hint: "Mit korrektem enumerate spielt der Bot richtig gut. Drücke ⏩ simulate für ein Bot-gegen-Bot-Spiel."
  }));
  feedbackSlot.replaceChildren(check(code));
}
mountEditor({ editor });
const section = mountGameSection({
  nodes: [boardSlot, feedbackSlot],
  onRun: () => { const b = editor.querySelector(".run-button"); if (b) b.click(); }
});
editor.addEventListener("input", () => { rerun(); section.expand(); });
rerun();
return {editor,boardSlot,feedbackSlot,check,rerun,section};
},
    inputs: ["codeEditor","starter","html","loadGame","err","ok","gameBoard","mountEditor","mountGameSection"],
    outputs: ["editor","boardSlot","feedbackSlot","check","rerun","section"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
